var render = function render(){var _vm=this,_c=_vm._self._c;return _c('md-radio',{staticClass:"md-radio",attrs:{"model":_vm.checked ? _vm.value : '',"value":_vm.value,"disabled":_vm.disabled},on:{"change":_vm.handleChange}},[_vm._v(_vm._s(_vm.label))])
}
var staticRenderFns = []

export { render, staticRenderFns }